import { Skeleton, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { visitApi } from 'src/api/visit';
import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import OrganizationProfessionalWaitingRoomTable from './OrganizationProfessionalWaitingRoomTable';
import OrganizationProfessionalWaitingRoomTableSkeleton from './OrganizationProfessionalWaitingRoomTableSkeleton';
import { translateKey } from 'src/locales/translate';


export const OrganizationProfessionalWaitingRoomContent = () => {
  const { professionalId } = useParams<{ professionalId: string }>();
  const {
    isProfessionalRoleSelected,
    isOrganizationAdminRoleSelected,
    selectedOrganization,
  } = useOrganizationContext();

  const { data, isLoading, refetch } = useQuery(
    ['professional-waiting-room', professionalId, selectedOrganization?.id],
    () =>
      visitApi.visitControllerGetTodaysVisitsByOrganizationAndProfessionalIdParam(
        {
          organizationId: selectedOrganization?.id!,
          professionalId: professionalId!,
        },
      ),
    {
      retry: 1,
      enabled:
        (isProfessionalRoleSelected || isOrganizationAdminRoleSelected) &&
        !!selectedOrganization?.id &&
        !!professionalId,
      refetchInterval: 30000,
    },
  );

  const visits = (data?.data ?? []).slice(1);

  return !isLoading && data ? (
    <>
      <Stack p={3}>
        <Typography variant="h6">{translateKey("visit.waitingRoomTodayTitle")}</Typography>
      </Stack>
      <OrganizationProfessionalWaitingRoomTable
        visits={visits}
        nextVisit={data?.data?.[0]}
        refetch={refetch}
      />
    </>
  ) : (
    <>
      <Stack p={3}>
        <Skeleton variant="rounded" height="28px" width="260px" />
      </Stack>
      <OrganizationProfessionalWaitingRoomTableSkeleton />
    </>
  );
};
